import React, { useContext, useEffect, useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";
import { BsChevronDown } from "@react-icons/all-files/bs/BsChevronDown";
import { BsXCircleFill } from "@react-icons/all-files/bs/BsXCircleFill";

import { useRouter } from "next/router";
import { StoreContext } from "../../context/context";
import { useTranslation } from "../../context/TranslationContext";

const SliderFormSelect = (props) => {
  const router = useRouter();
  const { currentRoutingTypeId } = useContext(StoreContext);
  const { select, selected } = useTranslation();
  const [isOpenx, setIsOpenx] = useState(false);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const [placeHolder, setPlaceHolder] = useState();

  const ToggleShow = (a = null) => {
    setIsOpenx(!isOpenx);
  };
  const CloseToggle = () => {
    setIsOpenx(false);
  };

  useEffect(() => {
    if (data.length == 0 && isOpenx)
      fetch(process.env.NEXT_PUBLIC_API + props.data)
        .then((res) => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setData(result.data);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        );
  }, [isOpenx]);

  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  const [checkedItems, setCheckedItems] = useState(null);
  const [checkedList, setCheckedList] = useState([]);

  const handleChange = (item, isChecked) => {
    setCheckedItems((prevState) => {
      let newState = { ...prevState };
      newState[item.value] = isChecked;

      // update parent items
      let parent = item.parent;
      while (parent) {
        // check if all child items are checked
        const allChildChecked = parent.children.every(
          (childItem) => newState[childItem.value]
        );
        newState[parent.value] = allChildChecked;
        parent = parent.parent;
      }

      // update child items
      if (item.children && item.children.length > 0) {
        item.children.forEach((childItem) => {
          newState[childItem.value] = isChecked;

          if (childItem.children && childItem.children.length > 0) {
            // update grandchild items
            childItem.children.forEach((grandchildItem) => {
              newState[grandchildItem.value] = isChecked;
            });
          }
        });
      }

      return newState;
    });
  };
  const renderItems = (items, parentItem) => {
    return (
      <div className="pl-2">
        {items.map((item) => {
          item.parent = parentItem;
          return (
            <div key={item.value} className="mb-2">
              <label className="flex items-center p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer group">
                <input
                  type="checkbox"
                  checked={
                    checkedItems && checkedItems[item.value] != undefined
                      ? checkedItems[item.value]
                      : false
                  }
                  onChange={(e) => handleChange(item, e.target.checked)}
                  className="w-4 h-4 text-blue-600 bg-white rounded border-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
                />
                <span className="ml-3 text-sm text-gray-700 group-hover:text-gray-900 transition-colors duration-200">
                  {item.label}
                </span>
              </label>
              {item.children &&
                item.children.length > 0 &&
                renderItems(item.children, item)}
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    if (data.length > 0) {
      if (props.setParam) {
        const a = {};
        a[props.name] = checkedList;
        props.setParam(a);
      } else {
        props.form[props.name] = checkedList;
        props.setForm(props.form);
      }
    }
    if (checkedList.length == 0) {
      setPlaceHolder(select);
    } else {
      setPlaceHolder(`${checkedList.length} ${selected}`);
    }
  }, [checkedList]);

  useEffect(() => {
    setCheckedList(getTrueKeys(checkedItems));
  }, [checkedItems]);

  useEffect(() => {
    const a = {};
    if (typeof router.query[props.name] == "object")
      router.query[props.name] &&
        router.query[props.name].map((i) => {
          a[i] = true;
        });
    else if (typeof router.query[props.name] == "string") {
      a[router.query[props.name]] = true;
    } else if (props.selected > 0) {
      a[props.selected] = true;
    }
    setCheckedItems(a);
  }, []);

  function getTrueKeys(obj) {
    const trueKeys = [];
    for (const key in obj) {
      if (obj[key] === true) {
        trueKeys.push(key);
      }
    }
    return trueKeys;
  }

  return (
    <div className={props.className} ref={ref}>
      <div
        className={
          "flex lg:justify-start justify-between items-center lg:items-stretch lg:flex-col pb-6 lg:pb-2  lg:px-6 border-b lg:border-b-0 lg:border-r border-brand-gray-3 cursor-pointer h-full " +
          (currentRoutingTypeId == "Home" ? "gap-y-3 pt-4" : "pt-2")
        }
        onClick={ToggleShow}
      >
        <label
          form="search_destination"
          className="text-sm lg:text-tiny font-bold text-brand-gray-2"
        >
          {props.label}
        </label>
        <div className="flex content-center items-center">
          <span className="text-tiny font-bold text-brand-black-2 overflow-hidden overflow-ellipsis whitespace-nowrap mr-3 lg:mr-0">
            {placeHolder}
          </span>
          <BsChevronDown className="ml-auto text-brand-gray-4" size="10" />
        </div>
      </div>
      {data && data.length > 0 && (
        <div
          className={
            "max-h-[300px] overflow-y-auto lg:max-h-max absolute min-w-max w-full bg-white left-0 shadow-2xl p-6 border border-gray-100 rounded-xl top-full transition-all duration-300 transform-gpu z-10 -mt-4 lg:mt-0 origin-top backdrop-blur-sm " +
            (isOpenx
              ? "scale-100 opacity-100"
              : "scale-95 opacity-0 pointer-events-none")
          }
        >
          <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-100">
            <h3 className="text-sm font-semibold text-gray-700">
              {props.label}
            </h3>
            <BsXCircleFill
              onClick={ToggleShow}
              className="text-gray-400 hover:text-gray-600 transition-colors duration-200 cursor-pointer"
              size="16"
            />
          </div>
          <div className="space-y-1">{renderItems(data)}</div>
        </div>
      )}
    </div>
  );
};

export default SliderFormSelect;
